import React, { useMemo, useState } from 'react';
import { TextInput } from '@mantine/core';
import { SectionCard } from '../../shared/SectionCard/SectionCard';
import { asCurrency } from '../../shared/utils/dashboard-page.utils';
import { SectionKey } from '../../shared/types/dashboard-page.types';
import { BestSellingProduct } from '../../../../services/reports/reports.service';
import classes from './best-selling-section.module.scss';

export type BestSellingSectionProps = {
  collapsedSections: Record<SectionKey, boolean>;
  toggleSection: (section: SectionKey) => void;
  bestSellingProducts: BestSellingProduct[];
};

export const BestSellingSection: React.FC<BestSellingSectionProps> = ({
  collapsedSections,
  toggleSection,
  bestSellingProducts,
}) => {
  const [search, setSearch] = useState('');

  const visibleProducts = useMemo(
    () => bestSellingProducts.filter((row) => {
      const query = search.toLowerCase();
      return row.productName.toLowerCase().includes(query) || row.categoryName.toLowerCase().includes(query);
    }),
    [bestSellingProducts, search],
  );

  return (
    <SectionCard
      title="הפריטים הנמכרים ביותר"
      sectionKey="bestSelling"
      collapsed={collapsedSections.bestSelling}
      onToggle={() => toggleSection('bestSelling')}
      titleExtra={<span className={classes.countBadge}>{`(${bestSellingProducts.length} פריטים)`}</span>}
    >
      <TextInput
        className={classes.searchInput}
        placeholder="חיפוש לפי שם פריט, קטגוריה..."
        value={search}
        onChange={(event) => setSearch(event.currentTarget.value)}
        data-testid="dashboard-best-selling-search"
      />

      {visibleProducts.length === 0 ? (
        <p className={classes.emptyHint}>אין נתונים להצגה</p>
      ) : (
        <div className={classes.list}>
          {visibleProducts.map((row) => (
            <div key={row.productId} className={classes.card}>
              <div className={classes.cell}>
                <span className={classes.cellLabel}>שם פריט</span>
                <span className={classes.cellValue}>{row.productName}</span>
              </div>
              <div className={classes.cell}>
                <span className={classes.cellLabel}>קטגוריה</span>
                <span className={classes.cellValue}>{row.categoryName}</span>
              </div>
              <div className={classes.cell}>
                <span className={classes.cellLabel}>כמות שנמכר</span>
                <span className={classes.cellValue}>{row.quantity}</span>
              </div>
              <div className={classes.cell}>
                <span className={classes.cellLabel}>מכירות</span>
                <span className={classes.cellValue}>{asCurrency(row.amount)}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </SectionCard>
  );
};
